module.exports = __webpack_public_path__ + "static/media/waiting_for_pickup_walking_man.ae3d8fd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/coolRide/images/waiting_for_pickup_walking_man.svg
// module id = 596
// module chunks = 0